import(/* webpackMode: "eager" */ "/app/app/load/page.tsx");
